export type MeasurementsJson = {
  Date: string;
  Eye: string;
  Distance: string;
  Direction: string;
  Tropia: string;
  Magnitude: string;
  Type: string;
  Subtype: string;
  Comitancy: string;
};

export type Measurement = {
  doctor_id?: string;
  clinic_user_id?: string;
  type?: MeasurementType;
  measurements_json?: MeasurementsJson | null;
  is_valid?: string;
  timestamp?: string;
  measurement_id?: string;
};

export type MeasurementAPIResponse = {
  success: string;
  measurements: Measurement[];
};

export enum MeasurementType {
  COVER_TEST = "Cover Test",
  NEAR_POINT_CONVERGENCE = "Near Point Convergence",
}
